import { PermissionType } from '@cbinsights/adminpermissionservice/adminpermissionservice';
import { teamPermissions } from 'client/modules/team/permissions/Team';
import {
  getSectionPage,
  useGetAdminPermissionsForUser,
} from 'client/utils/permissions-validation/hooks/UseGetAdminPermissionsForUserQuery';

export const useHasEditAccess = (): boolean => {
  const { data } = useGetAdminPermissionsForUser();

  const section = getSectionPage(
    data,
    teamPermissions.pageId,
    teamPermissions.sections[5].sectionId
  );

  return section.permissionTypes.includes(PermissionType.PUBLISH);
};

export default useHasEditAccess;
